export const branch = "https://storage.googleapis.com/public_viteslink_storage/images/invitation04/branch.png";
export const stem = "https://storage.googleapis.com/public_viteslink_storage/images/invitation04/stem.png";
export const flower = "https://storage.googleapis.com/public_viteslink_storage/images/invitation04/flower.png";
